import { useEffect, useState } from "react";
import MinimalArrow from "../components/MinimalArrow";
import img3 from '../assets/trattamenti/fisioterapia.jpg';
import treatments from '../assets/json/treatments.json';
import imageTesta from '../assets/trattamenti/testa-collo.jpg';
import imageSpalle from '../assets/trattamenti/spalla.jpg';
import imageGinocchio from '../assets/trattamenti/ginocchio.jpg';
import imageAnca from '../assets/trattamenti/anca.jpg';
import imagePiede from '../assets/trattamenti/Piede-caviglia.jpg';
import imageSchiena from '../assets/trattamenti/schiena.jpg';
import ContactForm from "../components/contactForm/ContactForm";


export default function PatologieTrattamenti() {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [fadeOut, setFadeOut] = useState(false);
    
    const imgPartiCorpo = [imageTesta, imageSpalle, imageGinocchio, imageAnca, imagePiede, imageSchiena]

    useEffect(() => {
      window.scrollTo(0, 0)
    }, [])

    useEffect(() => {
      const interval = setInterval(() => {
        setFadeOut(true); // Start fading out the current image
        setTimeout(() => {
          setCurrentIndex((prevIndex) => (prevIndex + 1) % imgPartiCorpo.length); // Change image
          setFadeOut(false); // Start fading in the new image
        }, 1000); // 1-second timeout for fade-out effect
      }, 5000); // Change every 5 seconds
  
      return () => clearInterval(interval); // Cleanup the interval on component unmount
    }, [imgPartiCorpo.length]);


return <>
  <MinimalArrow 
    title={'Patologie e trattamenti'}
    subtitle={'Offriamo una vasta gamma di trattamenti specializzati per affrontare svariate problematiche muscolo-scheletriche, dalla fisioterapia sportiva alla riabilitazione post-chirurgica. Ecco alcune delle nostre aree di intervento:'}
    backgroundImage={img3}
  />

  <div className="flex bg-black">
    <div className="w-2/5 h-screen sticky top-0 hidden md:block">
      <img 
        src={imgPartiCorpo[currentIndex]}  alt="parti corpo" 
        className={`object-cover w-full h-full transition-opacity duration-1000 ease-in-out ${ fadeOut ? 'opacity-0' : 'opacity-100' }`} 
      />
    </div>
    <div className="md:w-3/5 w-full relative flex flex-col items-center ">
    <h2 className="text-4xl font-semibold pt-12 text-mcare-green panoragraf-regular">Fisioterapia per Disturbi Specifici</h2>
      <div className="w-full h-full inset-0 ">
        <div className="relative text-white h-full pt-16 text-center flex flex-col items-center bg-black">
          {treatments.map((trattamento) =>
            <div key={trattamento.id} className="text-left mb-8 w-full max-w-2xl px-5">
              <h2  className='text-left text-3xl mb-9 mt-9 text-mcare-green'><b className=" panoragraf-light">{trattamento.region}</b></h2>
              <ul className='text-left '>
                  {trattamento.conditions.map((condition, index) => 
                  <li  key={index} className="mb-5 pb-3  mt-8">
                    <span className="text-xl"><b>{condition.name}:</b></span> 
                    <p className="pt-3"> 
                    {condition.treatments.map((treatment, idx) => {
                      if (idx === 0) {
                        // Capitalize the first letter of the first treatment
                        return treatment.charAt(0).toUpperCase() + treatment.slice(1);
                      }
                      // Make sure all other treatments start with lowercase
                      return treatment.charAt(0).toLowerCase() + treatment.slice(1);
                    }).join(', ')}
                      </p>
                  </li>
                  )}
              </ul>
          </div>
          )}
        </div>
      </div>
    </div>
  </div>
      {/* sez. contattaci */}
      <div className="grid grid-cols-4 gap-0" id='formContatti'>
        <div className="col-span-4 flex justify-center items-center py-32 bg-black">
            <div className="w-full absolute z-0" style={{"height":"120%"}}></div>
                <div className='w-full lg:w-2/6 z-30 px-5'>
                    <p className='text-center text-4xl font-semibold text-mcare-green panoragraf-light'>Prenota una visita</p>
                    <ContactForm 
                    LandingName='mcare'
                    Name={true}
                    NameClass='text-white'
                    NameText='Nome e Cognome:'
                    NameRequired={true}
                    Tel={true}
                    TelClass='text-white'
                    TelText='Telefono:'
                    TelRequired={true}
                    Email={true}
                    EmailClass='text-white'
                    EmailText='Email:'
                    EmailRequired={true}
                    Dropdown={true}
                    DropdownText="Scegli il centro:"
                    DropdownRequired={true}
                    DropdownItem={[' ', 'Mcare Verona', 'Mcare Sona']}
                    DropdownClass='text-slate-50'
                    ConsensoDati={true}
                    ConsensoDatiRequired={true}
                    ConsensoDatiText='Consenso dati'
                    ConsensoDatiID={1}
                    ConsensoDatiClass='text-white'
                    successText='Messaggio inviato con successo!'  
                    successLink='/'
                    errorText='Si è verificato un errore, Riprova!'
                    SendText='Invia'
                    SendClass='progress-button-mcare w-full'
                    borderType="border bg-[#65806e69]"
                    />
                </div>
            </div>
        </div>
</>
}